export default __webpack_public_path__ + "static/media/linkicon.6e68b06b.svg";